import React from "react";
function rgbToHex(r, g, b) {
  if (r > 255 || g > 255 || b > 255) throw "Invalid color component";
  return ((r << 16) | (g << 8) | b).toString(16);
}

function wtb(data, color = 255) {
  if (color === 256) {
    for (let i = 0; i < data.length; i += 4) {
      data[i + 3] = 0;
    }
  } else {
    for (let i = 0; i < data.length; i += 4) {
      if (data[i] <= 50 && data[i+1] <= 50 && data[i+2] <= 50 && data[i+3]>200) {
        data[i + 3] = 0;
      }
      if (data[i] > 100 || data[i+1] > 100 || data[i+2] > 100) {
        data[i] = color;
        data[i + 1] = color;
        data[i + 2] = color;
        data[i + 3] = 255;
      }
    }
  }
}

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 384,
      height: 512,
      pixels: [],
      color: 255,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.color !== this.state.color) {
      const ctx = this.canvas.getContext("2d");
      const img = new Image();
      img.crossOrigin = "anonymous";
      this.canvas.style.width = 384 + "px";
      this.canvas.style.height = 512 + "px";
      this.canvas.width = Math.floor(384);
      this.canvas.height = Math.floor(512);

      img.onload = () => {
        const width = 384;
        const height = 512;

        this.setState({ width, height });

        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, 384, 512);

        URL.revokeObjectURL(img.src);

        /* Read pixel data */
        const imageData = ctx.getImageData(0, 0, width, height);
        const data = imageData.data;
        // => [r,g,b,a,...]

        let pixels = [];

        wtb(imageData.data, this.state.color);
        ctx.putImageData(imageData, 0, 0);
      };
      img.src = this.props.segmented_image;
    }
  }

  componentDidMount() {
    const ctx = this.canvas.getContext("2d");
    const img = new Image();
    img.crossOrigin = "anonymous";
    this.canvas.style.width = 384 + "px";
    this.canvas.style.height = 512 + "px";
    this.canvas.width = Math.floor(384);
    this.canvas.height = Math.floor(512);

    img.onload = () => {
      const width = 384;
      const height = 512;

      this.setState({ width, height });

      ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, 384, 512);

      URL.revokeObjectURL(img.src);

      /* Read pixel data */
      const imageData = ctx.getImageData(0, 0, width, height);
      const data = imageData.data;
      // => [r,g,b,a,...]

      let pixels = [];

      wtb(imageData.data);
      ctx.putImageData(imageData, 0, 0);
    };
    img.src = this.props.segmented_image;
  }
  render() {
    const { width, height } = this.state;

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <canvas
          ref={(el) => (this.canvas = el)}
          style={{ position: "absolute" }}
        />

        <img
          src={this.props.image}
          width="384px"
          height="512px"
          style={{ position: "relative", zIndex: -2 }}
        />
        <button
          onClick={() => {
            let newColor;
            if (this.state.color === 255) {
              newColor = 0;
            } else if (this.state.color === 256) {
              newColor = 255;
            } else {
              newColor = 256;
            }
            this.setState({ color: newColor });
          }}
        >
          Convert color to{" "}
          {this.state.color >= 255
            ? this.state.color == 255
              ? "black"
              : "white"
            : "Transparent"}
        </button>
      </div>
    );
  }
}

//Logic for color to be corrected
